import PropTypes from "prop-types";
// Material Dashboard 2 React example components
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
} from "@mui/material";
import { Add, Description } from "@mui/icons-material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

const ListTemplates = (props) => {
  const { templates, handleClick, handleClickNew } = props;

  return (
    <Card>
      <CardHeader
        title="Plantillas"
        action={
          <IconButton aria-label="settings" onClick={() => handleClickNew(true)}>
            <Add fontSize="small" color="text"/>
          </IconButton>
        }
        sx={{ pb: 0 }}
      />
      <CardContent>
        <MDBox component="ul" display="flex" flexDirection="column" pb={0} m={0}>
          {templates.map((item) => (
            <MDBox
              key={item.id}
              py={0.5}
              onClick={() => handleClick(item.id)}
              sx={{
                display: "flex",
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <Description fontSize="small" color="text" sx={{ mr: 2 }} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ userSelect: "none" }}
              >
                {item.name}
              </MDTypography>
            </MDBox>
          ))}
        </MDBox>
      </CardContent>
    </Card>
  );
};

ListTemplates.propTypes = {
  templates: PropTypes.array,
  handleClick: PropTypes.func,
  handleClickNew: PropTypes.func,
};

export default ListTemplates;
